import { SortFunctionTableType, FieldType, DesirabilityFunctionType, isScoringType } from '@discngine/moosa-models';
import 'react';
import 'react-redux';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const selectTableInfo$1 = (state) => state.tableInfo;
createSelector(selectTableInfo$1, (tableInfo) => tableInfo.siderWidth);

function toColumnMetaInfo$1(fields) {
    return fields.map((field) => {
        var _a, _b;
        const histogramMax = Math.max(...(((_a = field.statistics) === null || _a === void 0 ? void 0 : _a.histogram) || [])) || 1; // todo temporary fix, wait for BE
        let histogramBars = [];
        let dataWidth = 0;
        const isDiscreteColumn = ((_b = field.statistics) === null || _b === void 0 ? void 0 : _b.textCategories) !== null;
        if (field.statistics && field.statistics.histogram) {
            const min = field.statistics.min;
            const max = field.statistics.max;
            const step = field.statistics.histogramStep || 1; // todo temporary fix, wait for BE
            dataWidth = max - min;
            histogramBars = field.statistics.histogram.map((yVal, index, arr) => {
                const bar = {
                    x0: min + step * index,
                    x: index === arr.length - 1 ? max : min + step * (index + 1),
                    y0: 0,
                    y: arr.length !== 0 ? yVal : yVal || 1, // todo temporary fix, wait for BE
                };
                return bar;
            });
        }
        const meta = Object.assign(Object.assign({}, field), { histogramMax,
            histogramBars,
            dataWidth,
            isDiscreteColumn });
        return meta;
    });
}

const DEFAULT_SIDER_WIDTH$1 = 355;
const MAX_SIDER_WIDTH$1 = DEFAULT_SIDER_WIDTH$1 * 2;
const initialState$2 = {
    id: '',
    name: '',
    isLoading: false,
    tableDataSize: 0,
    numRows: 0,
    numColumns: 0,
    columns: [],
    columnsMap: {},
    columnIds: [],
    columnIndexes: {},
    scoringTemplateId: null,
    comparisonScoringTemplateId: null,
    isTemplatesComparisonMode: false,
    missingValues: 0,
    siderWidth: DEFAULT_SIDER_WIDTH$1,
};
const tableInfoSlice$1 = createSlice({
    name: 'tableInfo',
    initialState: initialState$2,
    reducers: {
        initTableInfo(state, action) {
            const { data } = action.payload;
            state.id = data._id;
            state.name = data.fileName;
            state.tableDataSize = data.fileSize;
            state.numRows = data.rowCount;
            state.numColumns = data.fields.length;
            state.columns = toColumnMetaInfo$1(data.fields);
            state.columnIds = data.fields.map((field) => field.name);
            state.comparisonScoringTemplateId = null;
            state.isTemplatesComparisonMode = false;
            state.columnsMap = state.columns.reduce((acc, col) => {
                acc[col.name] = col;
                return acc;
            }, {});
            state.columnIndexes = state.columns.reduce((acc, col, index) => {
                acc[col.name] = index;
                return acc;
            }, {});
            // TODO need to discuss
            state.scoringTemplateId = {
                parentId: data.scoringTemplateId,
                id: data.scoringTemplateId,
            };
            state.missingValues = data.missingValues;
        },
        toggleTableInfoLoading(state, action) {
            state.isLoading = action.payload;
        },
        setIsTemplatesComparisonMode(state, action) {
            state.isTemplatesComparisonMode = action.payload;
        },
        setTableScoringTemplateId(state, action) {
            state.scoringTemplateId = action.payload
                ? { parentId: action.payload.parentId, id: action.payload.id }
                : null;
        },
        setTableComparisonScoringTemplateId(state, action) {
            state.comparisonScoringTemplateId = action.payload
                ? { parentId: action.payload.parentId, id: action.payload.id }
                : null;
        },
        setSiderWidth(state, action) {
            let width = action.payload;
            if (width > MAX_SIDER_WIDTH$1) {
                width = MAX_SIDER_WIDTH$1;
            }
            else if (width < DEFAULT_SIDER_WIDTH$1) {
                width = DEFAULT_SIDER_WIDTH$1;
            }
            state.siderWidth = width;
        },
    },
});
tableInfoSlice$1.actions;

function pointsCompare$1(p1, p2) {
    return p1.x === p2.x ? 0 : p1.x > p2.x ? 1 : -1;
}
function getValueFromLinearApprox$1(xVal, points) {
    const sortedPoints = [...points].sort(pointsCompare$1);
    const num = sortedPoints.length - 1;
    for (let i = 0; i < num; i++) {
        const point = sortedPoints[i];
        const next = sortedPoints[i + 1];
        if (point.x === xVal) {
            return point.y;
        }
        if (point.x <= xVal && xVal < next.x) {
            const fraction = (xVal - point.x) / (next.x - point.x);
            return point.y + (next.y - point.y) * fraction;
        }
    }
    return sortedPoints[num].y;
}
function toLine$1(points, range) {
    const sortedPoints = [...points].sort(pointsCompare$1);
    const line = sortedPoints.map((point) => (Object.assign(Object.assign({}, point), { mark: true })));
    return extendLineToRange$1(line, range);
}
function removeIndices(points) {
    return points.map(({ x, y, id }) => ({
        x,
        y,
    }));
}
function assignIndices(points) {
    return points.map((point, originalPointIndex) => (Object.assign(Object.assign({}, point), { originalPointIndex, id: v4() })));
}
/**
 * this function mutate points array
 */
function extendLineToRange$1(points, range) {
    const first = points[0];
    const last = points[points.length - 1];
    if (range.min < first.x) {
        points.unshift({
            id: v4(),
            x: range.min,
            y: first.y,
        });
    }
    if (range.max > last.x) {
        points.push({
            id: v4(),
            x: range.max,
            y: last.y,
        });
    }
    return points;
}
/**
 * To cover a case when statistics.min === statistics.max
 * (A dataset with one point, f. e.)
 * @param val
 */
function getRangeForSingleVal$1(val) {
    const delta = val === 0 ? 1 : Math.max(1, Math.abs(val / 10));
    return {
        min: val - delta,
        max: val + delta,
    };
}
/**
 * avoid same min and max
 * @param metadata
 */
function getRangeForInitialization(metadata) {
    var _a, _b;
    const min = ((_a = metadata.statistics) === null || _a === void 0 ? void 0 : _a.min) || 0;
    const max = ((_b = metadata.statistics) === null || _b === void 0 ? void 0 : _b.max) || 0;
    if (min === max) {
        return getRangeForSingleVal$1(min);
    }
    return { min, max };
}
function getRangeForLinearApprox$1(points, metadata) {
    const sortedPoints = [...points].sort(pointsCompare$1);
    const range = {
        min: Math.min(sortedPoints[0].x, metadata.statistics.min),
        max: Math.max(sortedPoints[sortedPoints.length - 1].x, metadata.statistics.max),
    };
    if (range.max === range.min) {
        return getRangeForSingleVal$1(range.max);
    }
    return range;
}
function updateLinePoint$1(points, { originalPointIndex, x: newX, y: newY }) {
    const pnts = [...points];
    const x = checkXBoundaries$1(newX);
    const y = checkYBoundaries$1(newY);
    const point = pnts.find((apoint) => apoint.originalPointIndex === originalPointIndex);
    point.x = x;
    // one of the points should stick to y:1
    if (point.y === 1) {
        // has more points at y:1
        // allow moving
        if (pnts.some((aPoint) => aPoint !== point && aPoint.y === 1)) {
            point.y = y;
        }
    }
    else {
        // y < 1 - allow moving
        point.y = y;
    }
    return { points: pnts };
}
const X_MIN$1 = -1e24;
const X_MAX$1 = 1e24;
function checkXBoundaries$1(x) {
    if (x < X_MIN$1) {
        return X_MIN$1;
    }
    if (x > X_MAX$1) {
        return X_MAX$1;
    }
    return x;
}
function checkYBoundaries$1(y) {
    if (y < 0) {
        return 0;
    }
    if (y > 1) {
        return 1;
    }
    return y;
}
const MAX_ERROR = 0.005;
/**
 * split range into segments to minimize error when approximate function by linear intervals
 *
 * @param initialPoints - array of initial points
 * @param fx - function f(x), we expect that f(x) has same sign of first derivative on each interval
 * @param dfx - derivative of f(x)
 */
function segmentation(initialPoints, fx, dfx) {
    const points = [...initialPoints].sort(pointsCompare$1);
    const rangesStack = [];
    for (let i = 0; i < points.length - 1; i++) {
        rangesStack.push([points[i], points[i + 1]]);
    }
    while (rangesStack.length) {
        const [p0, p1] = rangesStack.pop();
        const delta = p1.y - p0.y;
        const deltaApprox = dfx(p0.x) * (p1.x - p0.x);
        if (Math.abs(deltaApprox - delta) > MAX_ERROR) {
            const x = (p0.x + p1.x) / 2;
            const middle = {
                id: v4(),
                x,
                y: fx(x),
            };
            rangesStack.push([p0, middle]);
            rangesStack.push([middle, p1]);
            points.push(middle);
        }
    }
    return points.sort(pointsCompare$1);
}

const customCurveFunctionRules = {
    init(metadata) {
        const params = {
            points: [
                { x: metadata.statistics.min, y: 0, originalPointIndex: 0, id: v4() },
                { x: metadata.statistics.max, y: 1, originalPointIndex: 1, id: v4() },
            ],
        };
        return params;
    },
    getValue(xVal, params) {
        return getValueFromLinearApprox$1(xVal, params.points);
    },
    getRange(params, metadata) {
        return getRangeForLinearApprox$1(params.points, metadata);
    },
    toLine(params, range) {
        return toLine$1(params.points, range);
    },
    toServerTemplate(params) {
        return removeIndices(params.points);
    },
    fromServerTemplate(points) {
        return {
            points: assignIndices(points),
        };
    },
    movePoint(params, point) {
        return updateLinePoint$1(params.points, point);
    },
    addPoint(params, point) {
        const newParams = {
            points: [
                ...params.points,
                {
                    x: checkXBoundaries$1(point.x),
                    y: checkYBoundaries$1(point.y),
                    originalPointIndex: point.originalPointIndex,
                    id: v4(),
                },
            ].sort(pointsCompare$1),
        };
        return newParams;
    },
    removePoint(params, index) {
        if (params.points.length === 2) {
            return params;
        }
        const pointToRemove = params.points.find((point) => point.originalPointIndex === index);
        if (pointToRemove.y === 1) {
            // check if there are more points with y = 1
            if (!params.points.some((point) => point !== pointToRemove && point.y === 1)) {
                return params;
            }
        }
        const newParams = {
            points: params.points.filter((point) => point !== pointToRemove),
        };
        return newParams;
    },
};

function pointsCompare(p1, p2) {
    return p1.x === p2.x ? 0 : p1.x > p2.x ? 1 : -1;
}
function getValueFromLinearApprox(xVal, points) {
    const sortedPoints = [...points].sort(pointsCompare);
    const num = sortedPoints.length - 1;
    for (let i = 0; i < num; i++) {
        const point = sortedPoints[i];
        const next = sortedPoints[i + 1];
        if (point.x === xVal) {
            return point.y;
        }
        if (point.x <= xVal && xVal < next.x) {
            // @ts-ignore
            const fraction = (xVal - point.x) / (next.x - point.x);
            return point.y + (next.y - point.y) * fraction;
        }
    }
    return sortedPoints[num].y;
}
function toLine(points, range) {
    const line = points.reduce((acc, point, index) => {
        const fragment = [
            Object.assign(Object.assign({}, point), { 
                // to differentiate from original point
                id: v4(), x: index, y: 0, mark: false, originalPointIndex: point.isNotInFunction ? undefined : point.originalPointIndex }),
            Object.assign(Object.assign({}, point), { x: index, originalPointIndex: point.isNotInFunction ? undefined : point.originalPointIndex }),
            Object.assign(Object.assign({}, point), { 
                // to differentiate from original point
                id: v4(), x: index, y: 0, mark: false, originalPointIndex: point.isNotInFunction ? undefined : point.originalPointIndex }),
        ];
        acc.push(...fragment);
        return acc;
    }, []);
    return extendLineToRange(line, range);
}
function convertToServerNeededFormat(points) {
    return points
        .filter((point) => !point.isNotInFunction)
        .map(({ x, y }) => ({
        x,
        y,
    }));
}
/**
 * this function mutate points array
 */
function extendLineToRange(points, range) {
    const first = points[0];
    const last = points[points.length - 1];
    if (range.min < first.x) {
        points.unshift({
            id: v4(),
            x: range.min,
            y: first.y,
        });
    }
    if (range.max > last.x) {
        points.push({
            id: v4(),
            x: range.max,
            y: last.y,
        });
    }
    return points;
}
/**
 * To cover a case when statistics.min === statistics.max
 * (A dataset with one point, f. e.)
 * @param val
 */
function getRangeForSingleVal(val) {
    const delta = val === 0 ? 1 : Math.max(1, Math.abs(val / 10));
    return {
        min: val - delta,
        max: val + delta,
    };
}
function getRangeForLinearApprox(points, metadata) {
    const sortedPoints = [...points].sort(pointsCompare);
    const range = {
        min: Math.min(+sortedPoints[0].x, metadata.statistics.min),
        max: Math.max(+sortedPoints[sortedPoints.length - 1].x, metadata.statistics.max),
    };
    if (range.max === range.min) {
        return getRangeForSingleVal(range.max);
    }
    return range;
}
function updateLinePoint(points, { originalPointIndex, y: newY }) {
    const pnts = [...points];
    const y = checkYBoundaries(newY);
    const point = pnts.find((apoint) => apoint.originalPointIndex === originalPointIndex);
    point.y = y;
    return { points: pnts };
}
const X_MIN = -1e24;
const X_MAX = 1e24;
function checkXBoundaries(x) {
    if (x < X_MIN) {
        return X_MIN;
    }
    if (x > X_MAX) {
        return X_MAX;
    }
    return x;
}
function checkYBoundaries(y) {
    if (y < 0) {
        return 0;
    }
    if (y > 1) {
        return 1;
    }
    return y;
}

let initialIdCounter = 1;
function sortPoints(type, points, xSort, ySort) {
    if (type === FieldType.Number) {
        points.sort((point, nextPoint) => {
            if (xSort === SortFunctionTableType.Ascending) {
                return Number(point.x) - Number(nextPoint.x);
            }
            else if (xSort === SortFunctionTableType.Descending) {
                return Number(nextPoint.x) - Number(point.x);
            }
            else if (ySort === SortFunctionTableType.Descending) {
                return Number(nextPoint.y) - Number(point.y);
            }
            else if (ySort === SortFunctionTableType.Ascending) {
                return Number(point.y) - Number(nextPoint.y);
            }
            else {
                return 0;
            }
        });
    }
    if (type === FieldType.String) {
        points.sort(function (point, nextPoint) {
            if (xSort !== SortFunctionTableType.None) {
                const nameA = point.x.toString().toLowerCase();
                const nameB = nextPoint.x.toString().toLowerCase();
                if (xSort === SortFunctionTableType.Ascending) {
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                }
                else if (xSort === SortFunctionTableType.Descending) {
                    if (nameA > nameB) {
                        return -1;
                    }
                    if (nameA < nameB) {
                        return 1;
                    }
                    return 0;
                }
            }
            else if (ySort !== SortFunctionTableType.None) {
                if (ySort === SortFunctionTableType.Ascending) {
                    return Number(point.y) - Number(nextPoint.y);
                }
                else if (ySort === SortFunctionTableType.Descending) {
                    return Number(nextPoint.y) - Number(point.y);
                }
                else {
                    return 0;
                }
            }
            return 0;
        });
    }
    return points;
}
const discreteFunctionRules = {
    init(metadata) {
        if (metadata.isDiscreteColumn) {
            const initPoints = metadata.statistics.textCategories.map((point) => {
                const discretePoint = {
                    id: v4(),
                    x: point.value,
                    y: 0,
                    originalPointIndex: initialIdCounter++,
                    count: point.count,
                    isAddedByUser: false,
                    isNotInFunction: false,
                    mark: true,
                };
                return discretePoint;
            });
            const params = {
                points: sortPoints(metadata.type, initPoints, SortFunctionTableType.Ascending, SortFunctionTableType.None),
            };
            return params;
        }
        return null;
    },
    getValue(xVal, params) {
        return getValueFromLinearApprox(xVal, params.points);
    },
    getRange(params, metadata) {
        return getRangeForLinearApprox(params.points, metadata);
    },
    toLine(params, range) {
        return toLine(params.points, range);
    },
    toServerTemplate(params) {
        return convertToServerNeededFormat(params.points);
    },
    fromServerTemplate(points, metadata) {
        var _a;
        // todo check that it is correct column type
        const textCategories = ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.statistics) === null || _a === void 0 ? void 0 : _a.textCategories) || [];
        const pointsMap = new Map();
        points.forEach((point) => {
            // initialize like the point exists in function and absent in dataset
            const discretePoint = {
                id: v4(),
                x: point.x,
                y: point.y,
                originalPointIndex: initialIdCounter++,
                count: 0,
                isAddedByUser: true,
                isNotInFunction: false,
                mark: true,
            };
            pointsMap.set(String(point.x), discretePoint);
        });
        textCategories.forEach((category) => {
            const point = pointsMap.get(String(category.value));
            if (point) {
                // point both in function and in dataset
                point.count = category.count;
                point.isAddedByUser = false;
            }
            else {
                // point exists in dataset and absent in function
                const discretePointNotInFunction = {
                    id: v4(),
                    x: category.value,
                    y: 0,
                    originalPointIndex: initialIdCounter++,
                    count: category.count,
                    isAddedByUser: false,
                    isNotInFunction: true,
                    mark: false,
                };
                pointsMap.set(String(category.value), discretePointNotInFunction);
            }
        });
        const discretePoints = [...pointsMap.values()];
        return {
            points: discretePoints,
        };
    },
    movePoint(params, point) {
        return updateLinePoint(params.points, point);
    },
    addPoint(params, point, fieldType, xSort, ySort) {
        const newParams = {
            points: sortPoints(fieldType, [
                ...params.points,
                {
                    id: v4(),
                    x: checkXBoundaries(point.x),
                    y: checkYBoundaries(point.y),
                    originalPointIndex: initialIdCounter++,
                    isAddedByUser: true,
                    count: 0,
                    mark: true,
                },
            ], xSort, ySort),
        };
        return newParams;
    },
    removePoint(params, index) {
        const pointToRemove = params.points.find((point) => point.originalPointIndex === index);
        const newParams = {
            points: params.points.filter((point) => point !== pointToRemove),
        };
        return newParams;
    },
};

const linearFunctionRules = {
    init(metadata) {
        const { min, max } = getRangeForInitialization(metadata);
        return {
            points: [
                { x: min, y: 0, originalPointIndex: 0, id: v4() },
                { x: max, y: 1, originalPointIndex: 1, id: v4() },
            ],
        };
    },
    getValue(xVal, params) {
        return getValueFromLinearApprox$1(xVal, params.points);
    },
    getRange(params, metadata) {
        return getRangeForLinearApprox$1(params.points, metadata);
    },
    toLine(params, range) {
        return toLine$1(params.points, range);
    },
    toServerTemplate(params) {
        return removeIndices(params.points);
    },
    fromServerTemplate(points) {
        return { points: assignIndices(points) };
    },
    movePoint(params, point) {
        return updateLinePoint$1(params.points, point);
    },
};

/**
 * derivative for
 * Math.log( ((base - 1) * (xVal - params.xForY0)) / (params.xForY1 - params.xForY0) + 1 ) / Math.log(base)
 */
function logDerivative(val, params) {
    const { base, xForY0, xForY1 } = params;
    const _a = (base - 1) / (xForY1 - xForY0);
    const _b = xForY0;
    const _c = Math.log(base);
    return _a / (_a * _c * (val - _b) + _c);
}
const logarithmicFunctionRules = {
    init(metadata) {
        const params = {
            base: 2.718,
            xForY0: metadata.statistics.min,
            xForY1: metadata.statistics.min !== metadata.statistics.max
                ? metadata.statistics.max
                : metadata.statistics.min + 1,
        };
        return params;
    },
    getValue(xVal, params) {
        let minX, maxX, minY, maxY;
        if (params.xForY0 < params.xForY1) {
            minX = params.xForY0;
            minY = 0;
            maxX = params.xForY1;
            maxY = 1;
        }
        else {
            minX = params.xForY1;
            minY = 1;
            maxX = params.xForY0;
            maxY = 0;
        }
        if (xVal <= minX) {
            return minY;
        }
        if (xVal >= maxX) {
            return maxY;
        }
        const base = params.base === 1 ? 1.001 : params.base;
        return (Math.log(((base - 1) * (xVal - params.xForY0)) / (params.xForY1 - params.xForY0) + 1) / Math.log(base));
    },
    getRange(params, metadata) {
        const { min, max } = metadata.statistics;
        return {
            min: Math.min(min, params.xForY0, params.xForY1),
            max: Math.max(max, params.xForY0, params.xForY1),
        };
    },
    toLine(params, range) {
        const p0 = {
            id: 'first',
            x: params.xForY0,
            y: 0,
            originalPointIndex: 0,
            mark: true,
        };
        const p1 = {
            id: 'second',
            x: params.xForY1,
            y: 1,
            originalPointIndex: 1,
            mark: true,
        };
        const initialPoints = [p0, p1];
        const fx = (x) => logarithmicFunctionRules.getValue(x, params);
        const dfx = (x) => logDerivative(x, params);
        const points = segmentation(initialPoints, fx, dfx);
        // console.info('logarithm segmentation', points.length);
        return extendLineToRange$1(points, range);
    },
    toServerTemplate(params) {
        // TODO - a crutch: fix the crutch
        return [
            {
                x: params.xForY0,
                y: params.base,
            },
            {
                x: params.xForY1,
                y: 0,
            },
        ];
    },
    fromServerTemplate(points) {
        // TODO - and fix this as well
        return {
            base: points[0].y,
            xForY0: points[0].x,
            xForY1: points[1].x,
        };
    },
    movePoint(logParams, { originalPointIndex, x: newX }) {
        const params = Object.assign({}, logParams);
        const x = checkXBoundaries$1(newX);
        if (originalPointIndex === 0) {
            params.xForY0 = x;
        }
        else if (originalPointIndex === 1) {
            params.xForY1 = x;
        }
        return params;
    },
};

const rectangularFunctionRules = {
    init(metadata) {
        const { min, max } = getRangeForInitialization(metadata);
        const third = (2 * min + max) / 3;
        const twoThird = (min + 2 * max) / 3;
        const params = {
            points: [
                { x: min, y: 0, originalPointIndex: 0, id: v4() },
                { x: third, y: 1, originalPointIndex: 1, id: v4() },
                { x: twoThird, y: 1, originalPointIndex: 2, id: v4() },
                { x: max, y: 0, originalPointIndex: 3, id: v4() },
            ],
        };
        return params;
    },
    getValue(xVal, params) {
        return getValueFromLinearApprox$1(xVal, params.points);
    },
    getRange(params, metadata) {
        return getRangeForLinearApprox$1(params.points, metadata);
    },
    toLine(params, range) {
        return toLine$1(params.points, range);
    },
    toServerTemplate(params) {
        return removeIndices(params.points);
    },
    fromServerTemplate(points) {
        return { points: assignIndices(points) };
    },
    movePoint(params, point) {
        return updateLinePoint$1(params.points, point);
    },
};

// calculate first derivation of sigmoid function
function derivateSigmoid(val, params) {
    const { l, k, xCenter } = params;
    const _p = Math.exp(-k * (val - xCenter));
    return (k * l * _p) / ((_p + 1) * (_p + 1));
}
const sigmoidFunctionRules = {
    init(metadata) {
        const params = {
            l: 1,
            k: 1,
            xCenter: (metadata.statistics.max + metadata.statistics.min) / 2,
        };
        return params;
    },
    getValue(xVal, params) {
        const { l, k, xCenter } = params;
        /// L / (1 + exp(-K * (x - xCenter)))
        const sigmoid = 1 / (1 + Math.exp(-k * (xVal - xCenter)));
        if (l >= 0) {
            return l * sigmoid;
        }
        return l * sigmoid - l;
    },
    getRange(params, metadata) {
        const delta = (metadata.statistics.max - metadata.statistics.min) / 20;
        const interestingRange = [
            { x: params.xCenter - delta, y: 0, id: v4() },
            { x: params.xCenter + delta, y: 0, id: v4() },
        ];
        return getRangeForLinearApprox$1(interestingRange, metadata);
    },
    toLine(params, range) {
        const p0 = {
            id: 'min',
            x: range.min,
            y: sigmoidFunctionRules.getValue(range.min, params),
        };
        const p1 = {
            id: 'max',
            x: range.max,
            y: sigmoidFunctionRules.getValue(range.max, params),
        };
        const pCenter = {
            id: 'center',
            x: params.xCenter,
            y: sigmoidFunctionRules.getValue(params.xCenter, params),
            mark: true,
            originalPointIndex: 0,
        };
        const initialPoints = range.min <= params.xCenter && params.xCenter <= range.max
            ? [p0, pCenter, p1]
            : [p0, p1];
        const fx = (x) => sigmoidFunctionRules.getValue(x, params);
        const dfx = (x) => derivateSigmoid(x, params);
        const line = segmentation(initialPoints, fx, dfx);
        // console.info('sigmoid segmentation', line.length);
        return line;
    },
    toServerTemplate(params) {
        // TODO - a crutch: fix the crutch
        return [
            { x: params.l, y: params.k },
            { x: params.xCenter, y: 0 },
        ];
    },
    fromServerTemplate(points) {
        // TODO - and fix this as well
        return {
            l: points[0].x,
            k: points[0].y,
            xCenter: points[1].x,
        };
    },
    movePoint(sigParams, { originalPointIndex, x }) {
        const params = Object.assign({}, sigParams);
        // eslint-disable-next-line no-param-reassign
        x = checkXBoundaries$1(x);
        if (originalPointIndex === 0) {
            params.xCenter = x;
        }
        return params;
    },
};

const triangularFunctionRules = {
    init(metadata) {
        const { min, max } = getRangeForInitialization(metadata);
        const middle = (min + max) / 2;
        const params = {
            points: [
                { id: v4(), x: min, y: 0, originalPointIndex: 0 },
                { id: v4(), x: middle, y: 1, originalPointIndex: 1 },
                { id: v4(), x: max, y: 0, originalPointIndex: 2 },
            ],
        };
        return params;
    },
    getValue(xVal, params) {
        return getValueFromLinearApprox$1(xVal, params.points);
    },
    getRange(params, metadata) {
        return getRangeForLinearApprox$1(params.points, metadata);
    },
    toLine(params, range) {
        return toLine$1(params.points, range);
    },
    toServerTemplate(params) {
        return removeIndices(params.points);
    },
    fromServerTemplate(points) {
        return { points: assignIndices(points) };
    },
    movePoint(params, point) {
        return updateLinePoint$1(params.points, point);
    },
};

const unitStepFunctionRules = {
    init(metadata) {
        const params = {
            xStep: (metadata.statistics.max + metadata.statistics.min) / 2,
            yLeft: 0,
            yRight: 1,
        };
        return params;
    },
    getValue(xVal, params) {
        return xVal < params.xStep ? params.yLeft : params.yRight;
    },
    getRange(params, metadata) {
        const delta = (metadata.statistics.max - metadata.statistics.min) / 20;
        const interestingRange = [
            { id: v4(), x: params.xStep - delta, y: 0 },
            { id: v4(), x: params.xStep + delta, y: 0 },
        ];
        return getRangeForLinearApprox$1(interestingRange, metadata);
    },
    toLine(params, range) {
        const line = [
            { id: 'left', x: range.min, y: params.yLeft },
            {
                id: 'first',
                x: params.xStep,
                y: params.yLeft,
                mark: true,
                originalPointIndex: 0,
            },
            {
                id: 'second',
                x: params.xStep,
                y: params.yRight,
                mark: true,
                originalPointIndex: 1,
            },
            { id: 'right', x: range.max, y: params.yRight },
        ];
        if (range.min === params.xStep) {
            line.shift();
        }
        if (range.max === params.xStep) {
            line.pop();
        }
        return line;
    },
    toServerTemplate(params) {
        return [
            { x: params.xStep, y: params.yLeft },
            { x: params.xStep, y: params.yRight },
        ];
    },
    fromServerTemplate(points) {
        for (let i = 0; i < points.length - 1; ++i) {
            const point = points[i];
            const nextPoint = points[i + 1];
            if (point.x === nextPoint.x) {
                return {
                    yLeft: point.y,
                    yRight: nextPoint.y,
                    xStep: point.x,
                };
            }
        }
        throw new Error('wrong points set for the UniStep function');
    },
    movePoint(params, { originalPointIndex, x: newX, y: newY }) {
        const unistepParams = Object.assign({}, params);
        const x = checkXBoundaries$1(newX);
        const y = checkYBoundaries$1(newY);
        if (originalPointIndex === 0 && unistepParams.yLeft < 1) {
            unistepParams.yLeft = y;
            if (y === 0) {
                unistepParams.yRight = 1;
            }
            else if (y === 1) {
                unistepParams.yRight = 0;
            }
        }
        else if (originalPointIndex === 1 && unistepParams.yRight < 1) {
            unistepParams.yRight = y;
            if (y === 0) {
                unistepParams.yLeft = 1;
            }
            else if (y === 1) {
                unistepParams.yLeft = 0;
            }
        }
        unistepParams.xStep = x;
        return unistepParams;
    },
};

const SCORING_FUNCTIONS = [
    {
        name: 'Discrete Properties',
        type: DesirabilityFunctionType.discrete,
    },
    {
        name: 'Linear',
        type: DesirabilityFunctionType.linear,
    },
    {
        name: 'Logarithmic',
        type: DesirabilityFunctionType.logarithmic,
    },
    {
        name: 'Rectangular',
        type: DesirabilityFunctionType.rectangular,
    },
    {
        name: 'Triangular',
        type: DesirabilityFunctionType.triangular,
    },
    {
        name: 'Unit Step',
        type: DesirabilityFunctionType.unitStep,
    },
    {
        name: 'Logistic',
        type: DesirabilityFunctionType.sigmoid,
    },
    {
        name: 'Custom Curve',
        type: DesirabilityFunctionType.custom,
    },
];
const DEFAULT_TEMPLATE_SIZE = 5;
const SCORING_FUNCTIONS_RULES = {
    [DesirabilityFunctionType.linear]: linearFunctionRules,
    [DesirabilityFunctionType.unitStep]: unitStepFunctionRules,
    [DesirabilityFunctionType.triangular]: triangularFunctionRules,
    [DesirabilityFunctionType.rectangular]: rectangularFunctionRules,
    [DesirabilityFunctionType.logarithmic]: logarithmicFunctionRules,
    [DesirabilityFunctionType.sigmoid]: sigmoidFunctionRules,
    [DesirabilityFunctionType.custom]: customCurveFunctionRules,
    [DesirabilityFunctionType.discrete]: discreteFunctionRules,
};
function initScoringFunctionsParams(metadata) {
    const functionParams = {
        [DesirabilityFunctionType.linear]: linearFunctionRules.init(metadata),
        [DesirabilityFunctionType.unitStep]: unitStepFunctionRules.init(metadata),
        [DesirabilityFunctionType.triangular]: triangularFunctionRules.init(metadata),
        [DesirabilityFunctionType.rectangular]: rectangularFunctionRules.init(metadata),
        [DesirabilityFunctionType.logarithmic]: logarithmicFunctionRules.init(metadata),
        [DesirabilityFunctionType.sigmoid]: sigmoidFunctionRules.init(metadata),
        [DesirabilityFunctionType.custom]: customCurveFunctionRules.init(metadata),
        [DesirabilityFunctionType.discrete]: discreteFunctionRules.init(metadata),
    };
    return functionParams;
}
const DEFAULT_COLORS = [
    '#e4744e',
    '#f2b06e',
    '#f6e652',
    '#98d268',
    '#489556',
    '#51a4aa',
    '#0093dc',
    '#5276bb',
    '#a376c2',
    '#92656e',
    '#ee7d87',
    '#b34454',
    '#bdba6f',
    '#e9f3a3',
    '#bed4a9',
    '#a0dbdd',
    '#c6f0fd',
    '#5041ad',
    '#bd9da4',
    '#828282',
];
const DEFAULT_COLORS_LENGTH = DEFAULT_COLORS.length;
function* getColor() {
    let i = 0;
    while (true) {
        yield DEFAULT_COLORS[i++];
        if (i === DEFAULT_COLORS_LENGTH) {
            i = 0;
        }
    }
}
const colorGenerator$1 = getColor();
function getDefaultScoringFunction(metadata) {
    const type = metadata.isDiscreteColumn
        ? DesirabilityFunctionType.discrete
        : DesirabilityFunctionType.linear;
    return {
        column: metadata.name,
        color: colorGenerator$1.next().value,
        isInUse: true,
        weight: 1,
        type,
        functionParams: initScoringFunctionsParams(metadata),
        measurementError: { type: 'none' },
        isDiscreteStringFunction: metadata.isDiscreteColumn && metadata.type === FieldType.String,
    };
}
function columnsToScoringFunctions(fields) {
    const numberFields = fields
        .filter((val) => isScoringType(val.type, val.isDiscreteColumn))
        .slice(0, DEFAULT_TEMPLATE_SIZE);
    const allMetadata = toColumnMetaInfo$1(numberFields); // todo rewrite without this conversion
    const scoringFunction = allMetadata.reduce((acc, metadata) => {
        acc[metadata.name] = getDefaultScoringFunction(metadata);
        return acc;
    }, {});
    return scoringFunction;
}

const selectScoringTemplate = (state) => state.scoringTemplate;
const selectScoringFunction = (state) => state.scoringTemplate.func;
const selectScoringOpenPropertyPanels = (state) => state.scoringTemplate.openPropertyPanels;
const selectScoringColumnOrder = (state) => state.scoringTemplate.order;
const selectScoringTemplateChanged = (state) => state.scoringTemplate.changed;
const selectScoringFunctionByColumn = (column) => createSelector((state) => state.scoringTemplate.func, (func) => func[column]);
const selectPropertyPanelOpen = (column) => createSelector((state) => state.scoringTemplate, (scoringTemplate) => !!scoringTemplate.openPropertyPanels[column]);
const selectScoringWeight = (column) => createSelector((state) => state.scoringTemplate.func, (func) => func[column].weight);
const selectMissingValue = (column) => createSelector((state) => state.scoringTemplate.func, (func) => { var _a; return (_a = func[column].missingValue) === null || _a === void 0 ? void 0 : _a.replaceWith; });
const selectMeasurementError = (column) => createSelector((state) => state.scoringTemplate.func, (func) => func[column].measurementError);
const selectErrorsAvailable = (state) => Object.values(state.scoringTemplate.func).some((col) => col.measurementError.type !== 'none');
const selectMissingValueY = (column) => createSelector((state) => state.scoringTemplate.func, (func) => { var _a; return (_a = func[column].missingValue) === null || _a === void 0 ? void 0 : _a.replaceWithY; });
const selectMissingValueReplacementColumn = (column) => createSelector((state) => state.scoringTemplate.func, (func) => { var _a; return (_a = func[column].missingValue) === null || _a === void 0 ? void 0 : _a.replaceWithColumn; });
const selectFilterFrom = (column) => createSelector((state) => state.scoringTemplate.func, (func) => { var _a; return (_a = func[column].filter) === null || _a === void 0 ? void 0 : _a.from; });
const selectFilterTo = (column) => createSelector((state) => state.scoringTemplate.func, (func) => { var _a; return (_a = func[column].filter) === null || _a === void 0 ? void 0 : _a.to; });
const selectCustomFunctions = (state) => state.scoringTemplate.customFunctions;
const selectScoringTemplateData = createSelector(selectScoringColumnOrder, selectScoringFunction, (order, func) => ({ order, func }));

const colorGenerator = getColor();
var DesirabilityFunctionLineSerialization;
(function (DesirabilityFunctionLineSerialization) {
    DesirabilityFunctionLineSerialization["LINE"] = "line";
    DesirabilityFunctionLineSerialization["PARAMS"] = "params";
})(DesirabilityFunctionLineSerialization || (DesirabilityFunctionLineSerialization = {}));
const convertTemplateToTableDataType = (template, columnMap) => {
    let func = {};
    let order = [];
    if (template) {
        template.columns.forEach(({ columnName, color, isVisible, weight, filter, missingValue, measurementError, desirability: { points, type, name }, isDiscreteStringFunction, }) => {
            var _a;
            const metadata = columnMap[columnName];
            let functionParams = {};
            if (isScoringType(metadata === null || metadata === void 0 ? void 0 : metadata.type, (_a = columnMap[columnName]) === null || _a === void 0 ? void 0 : _a.isDiscreteColumn)) {
                functionParams = initScoringFunctionsParams(metadata);
            }
            functionParams[type] = SCORING_FUNCTIONS_RULES[type].fromServerTemplate(points.map((point) => (Object.assign(Object.assign({}, point), { id: v4() }))), metadata);
            func[columnName] = {
                column: columnName,
                color: color !== null && color !== void 0 ? color : colorGenerator.next().value,
                isInUse: isVisible,
                weight,
                type,
                name,
                functionParams,
                missingValue,
                filter,
                measurementError: measurementError || { type: 'none' },
                isDiscreteStringFunction: (metadata === null || metadata === void 0 ? void 0 : metadata.isDiscreteColumn) && isDiscreteStringFunction,
            };
            order.push(columnName);
        });
    }
    return { func, order };
};
function saveDesirabilityFunction(createDesirabilityFunction, name, property) {
    return async () => {
        const payload = desirabilityFunctionToPayload(name, property);
        await createDesirabilityFunction(payload);
    };
}
function scoringFunctionToPayload(name, template, allMetadata = null, pointsSerialization = DesirabilityFunctionLineSerialization.PARAMS) {
    let columns = template === null || template === void 0 ? void 0 : template.order;
    if (pointsSerialization === DesirabilityFunctionLineSerialization.LINE) {
        columns = columns === null || columns === void 0 ? void 0 : columns.filter((col) => allMetadata && allMetadata[col]);
    }
    const columnsData = columns
        .map((col) => template.func[col])
        .map((property) => {
        const rules = SCORING_FUNCTIONS_RULES[property.type];
        const params = property.functionParams[property.type];
        let points;
        switch (pointsSerialization) {
            case DesirabilityFunctionLineSerialization.LINE:
                const metadata = allMetadata[property.column];
                const range = SCORING_FUNCTIONS_RULES[property.type].getRange(params, metadata);
                if (property.type === DesirabilityFunctionType.discrete) {
                    points = params.points
                        .filter((pointF) => !(pointF === null || pointF === void 0 ? void 0 : pointF.isNotInFunction))
                        .map((point) => ({ x: point.x, y: point.y }));
                }
                else {
                    //@ts-ignore
                    points = rules.toLine(params, range).map(({ x, y }) => ({ x, y }));
                }
                break;
            case DesirabilityFunctionLineSerialization.PARAMS:
                points = rules.toServerTemplate(params);
                break;
            default:
                throw new Error();
        }
        const item = {
            color: property.color,
            columnName: property.column,
            isVisible: property.isInUse,
            weight: property.weight,
            desirability: {
                type: property.type,
                name: property.name,
                points,
            },
            missingValue: property.missingValue,
            measurementError: property.measurementError,
            filter: property.filter,
            isDiscreteStringFunction: property.isDiscreteStringFunction,
        };
        return item;
    });
    return {
        name,
        columns: columnsData,
    };
}
function desirabilityFunctionToPayload(name, property) {
    const { functionParams, type, isDiscreteStringFunction } = property;
    const rules = SCORING_FUNCTIONS_RULES[type];
    const params = functionParams[type];
    const points = rules.toServerTemplate(params);
    return {
        name,
        points,
        type,
        isDiscreteStringFunction,
    };
}

const initialState$1 = {
    func: {},
    changed: false,
    order: [],
    openPropertyPanels: {},
    customFunctions: [],
};
const scoringTemplateSlice = createSlice({
    name: 'scoringTemplate',
    initialState: initialState$1,
    reducers: {
        setScoringWeight(state, { payload: { col, weight } }) {
            state.func[col].weight = weight;
            state.changed = true;
        },
        toggleColumnInScoring(state, action) {
            state.func[action.payload.col].isInUse = action.payload.isInUse;
            state.changed = true;
        },
        changeDesirabilityFunction(state, action) {
            const { column, name, metadata } = action.payload;
            const predefined = SCORING_FUNCTIONS.find((func) => func.name === name);
            let type, functionParams;
            if (predefined) {
                type = predefined.type;
                functionParams = SCORING_FUNCTIONS_RULES[type].init(metadata);
            }
            else {
                const custom = state.customFunctions.find((func) => func.name === name);
                type = custom.type;
                functionParams = SCORING_FUNCTIONS_RULES[type].fromServerTemplate(custom.points.map((point) => (Object.assign(Object.assign({}, point), { id: v4() }))), metadata);
            }
            state.func[column].type = type;
            state.func[column].name = name;
            if (type === DesirabilityFunctionType.discrete) {
                state.func[column].isDiscreteStringFunction = metadata.type === FieldType.String;
            }
            state.func[column].functionParams[type] = functionParams;
            state.changed = true;
        },
        changeDesirabilityParams(state, action) {
            const { column, type, params } = action.payload;
            state.func[column].functionParams[type] = params;
            state.changed = true;
        },
        setFromSavedTemplate(state, action) {
            const { template, columnMap } = action.payload;
            const convertedTemplate = convertTemplateToTableDataType(template, columnMap);
            state.func = convertedTemplate.func;
            state.order = convertedTemplate.order;
            state.changed = false;
        },
        templateSaved(state) {
            state.changed = false;
        },
        changeColumnOrder(state, action) {
            const { fromColumn, toColumn } = action.payload;
            const order = state.order;
            const fromIndex = order.indexOf(fromColumn);
            const toIndex = order.indexOf(toColumn);
            const item = order.splice(fromIndex, 1)[0];
            order.splice(toIndex, 0, item);
            state.changed = true;
        },
        addColumnToScoring(state, action) {
            const { colId, metadata } = action.payload;
            state.func[colId] = getDefaultScoringFunction(metadata);
            state.order.unshift(colId);
            state.openPropertyPanels[colId] = 1;
            state.changed = true;
        },
        removeColumnFromScoring(state, action) {
            const colId = action.payload;
            const index = state.order.indexOf(colId);
            state.order.splice(index, 1);
            delete state.func[colId];
            delete state.openPropertyPanels[colId];
            state.changed = true;
        },
        initFromTableMetadata(state, action) {
            state.func = {};
            state.order = [];
            state.openPropertyPanels = {};
            state.changed = false;
        },
        resetToDefault(state) {
            state.func = {};
            state.order = [];
            state.openPropertyPanels = {};
            state.changed = false;
        },
        setColumnColor(state, { payload: { column, color } }) {
            state.func[column].color = color;
            state.changed = true;
        },
        toggleColumnPropertyOpen(state, { payload: { column, open } }) {
            if (open) {
                state.openPropertyPanels[column] = 1;
            }
            else {
                delete state.openPropertyPanels[column];
            }
        },
        movePoint(state, { payload: { column, type, point }, }) {
            const params = state.func[column].functionParams[type];
            // @ts-ignore
            state.func[column].functionParams[type] = SCORING_FUNCTIONS_RULES[type].movePoint(params, point);
            state.changed = true;
        },
        addPoint(state, { payload: { column, type, point, fieldType, xSort, ySort }, }) {
            const params = state.func[column].functionParams[type];
            // @ts-ignore
            state.func[column].functionParams[type] = SCORING_FUNCTIONS_RULES[type].addPoint(params, Object.assign(Object.assign({}, point), { id: v4() }), fieldType, xSort, ySort);
            state.changed = true;
        },
        removePoint(state, { payload: { column, type, index }, }) {
            const params = state.func[column].functionParams[type];
            // @ts-ignore
            state.func[column].functionParams[type] = SCORING_FUNCTIONS_RULES[type].removePoint(params, index);
            state.changed = true;
        },
        changeDiscretePointsOrder(state, action) {
            const { fromPoint, toPoint, columnName } = action.payload;
            const points = state.func[columnName].functionParams[DesirabilityFunctionType.discrete].points;
            const fromIndex = points.findIndex((point) => point.x === fromPoint);
            const toIndex = points.map((point) => point.x).indexOf(toPoint);
            const item = points.splice(fromIndex, 1)[0];
            points.splice(toIndex, 0, item);
            state.changed = true;
        },
        setMissingValue(state, action) {
            const { colId, replaceWith, replaceWithY: y, replaceWithColumn, isDiscreteStringFunction, } = action.payload;
            const hasX = typeof replaceWith === 'number' ||
                (isDiscreteStringFunction && typeof replaceWithColumn !== 'string');
            const hasY = typeof y === 'number';
            const hasColumn = typeof replaceWithColumn === 'string';
            if (hasX && hasY) {
                throw Error('Both replaceWith and replaceWithY were set');
            }
            let replaceWithY = y;
            if (hasY) {
                if (y < 0) {
                    replaceWithY = 0;
                }
                else if (y > 1) {
                    replaceWithY = 1;
                }
            }
            if (hasX || hasY || hasColumn) {
                state.func[colId].missingValue = { replaceWith, replaceWithY, replaceWithColumn };
            }
            else {
                delete state.func[colId].missingValue;
            }
            state.changed = true;
        },
        setErrorMode(state, action) {
            state.func[action.payload.colId].measurementError = action.payload.measurementError;
            state.changed = true;
        },
        setFilterFrom(state, action) {
            const { colId, from } = action.payload;
            let filter = state.func[colId].filter;
            if (!filter) {
                filter = {};
                state.func[colId].filter = filter;
            }
            if (typeof from === 'number') {
                filter.from = from;
            }
            else {
                delete filter.from;
            }
            state.changed = true;
        },
        setFilterTo(state, action) {
            const { colId, to } = action.payload;
            let filter = state.func[colId].filter;
            if (!filter) {
                filter = {};
                state.func[colId].filter = filter;
            }
            if (typeof to === 'number') {
                filter.to = to;
            }
            else {
                delete filter.to;
            }
            state.changed = true;
        },
        reassignColumn(state, action) {
            const { oldColumn, newColumn, metadata } = action.payload;
            const index = state.order.indexOf(oldColumn);
            state.func[newColumn] = getDefaultScoringFunction(metadata);
            delete state.func[oldColumn];
            state.order[index] = newColumn;
            if (state.openPropertyPanels[oldColumn]) {
                state.openPropertyPanels[newColumn] = 1;
                delete state.openPropertyPanels[oldColumn];
            }
            state.changed = true;
        },
        setCustomFunctions(state, action) {
            state.customFunctions = action.payload.functions;
        },
        setScoringTemplateState(state, action) {
            state.func = action.payload.templateState.func;
            state.changed = action.payload.templateState.changed;
            state.order = action.payload.templateState.order;
            state.openPropertyPanels = action.payload.templateState.openPropertyPanels;
            state.customFunctions = action.payload.templateState.customFunctions;
        },
    },
});
const { setScoringWeight, toggleColumnInScoring, changeDesirabilityFunction, changeDesirabilityParams, setFromSavedTemplate, templateSaved, addColumnToScoring, removeColumnFromScoring, changeColumnOrder, initFromTableMetadata, resetToDefault, setColumnColor, toggleColumnPropertyOpen, movePoint, addPoint, removePoint, setMissingValue, setErrorMode, setFilterFrom, setFilterTo, reassignColumn, setCustomFunctions, changeDiscretePointsOrder, setScoringTemplateState, } = scoringTemplateSlice.actions;

const selectTableInfo = (state) => state.tableInfo;
const selectTableId = (state) => state.tableInfo.id;
createSelector(selectTableInfo, (tableInfo) => tableInfo.siderWidth);

function toColumnMetaInfo(fields) {
    return fields.map((field) => {
        var _a, _b;
        const histogramMax = Math.max(...(((_a = field.statistics) === null || _a === void 0 ? void 0 : _a.histogram) || [])) || 1; // todo temporary fix, wait for BE
        let histogramBars = [];
        let dataWidth = 0;
        const isDiscreteColumn = ((_b = field.statistics) === null || _b === void 0 ? void 0 : _b.textCategories) !== null;
        if (field.statistics && field.statistics.histogram) {
            const min = field.statistics.min;
            const max = field.statistics.max;
            const step = field.statistics.histogramStep || 1; // todo temporary fix, wait for BE
            dataWidth = max - min;
            histogramBars = field.statistics.histogram.map((yVal, index, arr) => {
                const bar = {
                    x0: min + step * index,
                    x: index === arr.length - 1 ? max : min + step * (index + 1),
                    y0: 0,
                    y: arr.length !== 0 ? yVal : yVal || 1, // todo temporary fix, wait for BE
                };
                return bar;
            });
        }
        const meta = Object.assign(Object.assign({}, field), { histogramMax,
            histogramBars,
            dataWidth,
            isDiscreteColumn });
        return meta;
    });
}

const DEFAULT_SIDER_WIDTH = 355;
const MAX_SIDER_WIDTH = DEFAULT_SIDER_WIDTH * 2;
const initialState = {
    id: '',
    name: '',
    isLoading: false,
    tableDataSize: 0,
    numRows: 0,
    numColumns: 0,
    columns: [],
    columnsMap: {},
    columnIds: [],
    columnIndexes: {},
    scoringTemplateId: null,
    comparisonScoringTemplateId: null,
    isTemplatesComparisonMode: false,
    missingValues: 0,
    siderWidth: DEFAULT_SIDER_WIDTH,
};
const tableInfoSlice = createSlice({
    name: 'tableInfo',
    initialState,
    reducers: {
        initTableInfo(state, action) {
            const { data } = action.payload;
            state.id = data._id;
            state.name = data.fileName;
            state.tableDataSize = data.fileSize;
            state.numRows = data.rowCount;
            state.numColumns = data.fields.length;
            state.columns = toColumnMetaInfo(data.fields);
            state.columnIds = data.fields.map((field) => field.name);
            state.comparisonScoringTemplateId = null;
            state.isTemplatesComparisonMode = false;
            state.columnsMap = state.columns.reduce((acc, col) => {
                acc[col.name] = col;
                return acc;
            }, {});
            state.columnIndexes = state.columns.reduce((acc, col, index) => {
                acc[col.name] = index;
                return acc;
            }, {});
            // TODO need to discuss
            state.scoringTemplateId = {
                parentId: data.scoringTemplateId,
                id: data.scoringTemplateId,
            };
            state.missingValues = data.missingValues;
        },
        toggleTableInfoLoading(state, action) {
            state.isLoading = action.payload;
        },
        setIsTemplatesComparisonMode(state, action) {
            state.isTemplatesComparisonMode = action.payload;
        },
        setTableScoringTemplateId(state, action) {
            state.scoringTemplateId = action.payload
                ? { parentId: action.payload.parentId, id: action.payload.id }
                : null;
        },
        setTableComparisonScoringTemplateId(state, action) {
            state.comparisonScoringTemplateId = action.payload
                ? { parentId: action.payload.parentId, id: action.payload.id }
                : null;
        },
        setSiderWidth(state, action) {
            let width = action.payload;
            if (width > MAX_SIDER_WIDTH) {
                width = MAX_SIDER_WIDTH;
            }
            else if (width < DEFAULT_SIDER_WIDTH) {
                width = DEFAULT_SIDER_WIDTH;
            }
            state.siderWidth = width;
        },
    },
});
const { initTableInfo, toggleTableInfoLoading, setTableScoringTemplateId, setTableComparisonScoringTemplateId, setIsTemplatesComparisonMode, setSiderWidth, } = tableInfoSlice.actions;

function assignScoringTemplate(service, templateId) {
    return async (dispatch, getState) => {
        const state = getState();
        const tableId = selectTableId(state);
        console.info('assign scoring template', templateId, ' to table', tableId);
        try {
            const assignResponse = await service.assignScoringTemplate(tableId, templateId);
            console.info('COMPLETE assign scoring template', assignResponse);
        }
        catch (error) {
            console.error(error);
        }
    };
}
function unassignScoringTemplate(service) {
    return async (dispatch, getState) => {
        const state = getState();
        const tableId = selectTableId(state);
        console.info('unassign scoring template to table', tableId);
        try {
            const assignResponse = await service.assignScoringTemplate(tableId, null);
            console.info('COMPLETE unassign scoring template', assignResponse);
        }
        catch (error) {
            console.error(error);
        }
    };
}
function fetchDesirabilityFunctions(service) {
    return async (dispatch) => {
        console.info('fetchDesirabilityFunctions');
        try {
            const { data: functions, total } = await service.getDesirabilityFunctionList();
            let allFunctions = [...functions];
            if (total > functions.length) {
                // it's the case, when we have more custom functions than initial requested limit
                const newLimit = total - functions.length;
                const newSkip = functions.length;
                const { data: restFunctions } = await service.getDesirabilityFunctionList({
                    skip: newSkip,
                    limit: newLimit,
                });
                allFunctions = [...functions, ...restFunctions];
            }
            dispatch(setCustomFunctions({ functions: allFunctions }));
            console.info('COMPLETE fetchDesirabilityFunctions', functions.length);
        }
        catch (error) {
            console.error(error);
        }
    };
}
function getPayloadForSavingTemplate(getState, name) {
    const state = getState();
    const template = selectScoringTemplate(state);
    return scoringFunctionToPayload(name, template);
}
async function afterSavingTemplate(dispatch, service, assignedTemplateId) {
    await dispatch(assignScoringTemplate(service, assignedTemplateId));
    dispatch(templateSaved());
}
function createScoringTemplate(service, name, onSaveCallback) {
    return async (dispatch, getState) => {
        var _a;
        console.info('createScoringTemplate', name);
        try {
            const payload = getPayloadForSavingTemplate(getState, name);
            const response = await onSaveCallback(Object.assign(Object.assign({}, payload), { name, columns: (_a = payload.columns) !== null && _a !== void 0 ? _a : [] }));
            console.info('COMPLETE save new scoring template', response);
            if (!response._id) {
                console.error(`Response doesn't contain '_id' field. Attention!`);
                return;
            }
            const parentId = response.parentId || response._id;
            dispatch(setTableScoringTemplateId({ parentId: parentId, id: response._id }));
            const assignedTemplateId = response._id;
            await afterSavingTemplate(dispatch, service, assignedTemplateId);
        }
        catch (error) {
            console.error(error);
            // let the app handle error
            throw error;
        }
    };
}
function updateScoringTemplate(service, template, onUpdateCallback) {
    return async (dispatch, getState) => {
        try {
            const payload = getPayloadForSavingTemplate(getState, template.name);
            const response = await onUpdateCallback(Object.assign(Object.assign(Object.assign({}, template), payload), { name: template.name }));
            if (!response._id) {
                console.error(`Response doesn't contain '_id' field. Attention!`);
                return;
            }
            const assignedTemplateId = response._id;
            await afterSavingTemplate(dispatch, service, assignedTemplateId);
        }
        catch (error) {
            console.error(error);
            // let the app handle error
            throw error;
        }
    };
}
function createScoringTemplateVersion(service, onSaveCallback, parentTemplateId, name, versionName, description) {
    return async (dispatch, getState) => {
        var _a;
        try {
            const payload = getPayloadForSavingTemplate(getState, name);
            payload.parentId = parentTemplateId;
            payload.description = description;
            payload.versionName = `${versionName}`;
            const response = await onSaveCallback(Object.assign(Object.assign({}, payload), { name, columns: (_a = payload.columns) !== null && _a !== void 0 ? _a : [] }));
            console.info('COMPLETE saving new version of scoring template', response);
            if (!response._id) {
                console.error(`Response doesn't contain '_id' field. Attention!`);
                return;
            }
            dispatch(setTableScoringTemplateId({ parentId: parentTemplateId, id: response._id }));
            const assignedTemplateId = response._id;
            await afterSavingTemplate(dispatch, service, assignedTemplateId);
        }
        catch (error) {
            console.error(error);
        }
    };
}

export { DEFAULT_COLORS, DEFAULT_TEMPLATE_SIZE, DesirabilityFunctionLineSerialization, SCORING_FUNCTIONS, SCORING_FUNCTIONS_RULES, addColumnToScoring, addPoint, assignScoringTemplate, changeColumnOrder, changeDesirabilityFunction, changeDesirabilityParams, changeDiscretePointsOrder, columnsToScoringFunctions, convertTemplateToTableDataType, createScoringTemplate, createScoringTemplateVersion, desirabilityFunctionToPayload, fetchDesirabilityFunctions, getColor, getDefaultScoringFunction, initFromTableMetadata, initScoringFunctionsParams, movePoint, reassignColumn, removeColumnFromScoring, removePoint, resetToDefault, saveDesirabilityFunction, scoringFunctionToPayload, scoringTemplateSlice, selectCustomFunctions, selectErrorsAvailable, selectFilterFrom, selectFilterTo, selectMeasurementError, selectMissingValue, selectMissingValueReplacementColumn, selectMissingValueY, selectPropertyPanelOpen, selectScoringColumnOrder, selectScoringFunction, selectScoringFunctionByColumn, selectScoringOpenPropertyPanels, selectScoringTemplate, selectScoringTemplateChanged, selectScoringTemplateData, selectScoringWeight, setColumnColor, setCustomFunctions, setErrorMode, setFilterFrom, setFilterTo, setFromSavedTemplate, setMissingValue, setScoringTemplateState, setScoringWeight, templateSaved, toggleColumnInScoring, toggleColumnPropertyOpen, unassignScoringTemplate, updateScoringTemplate };
//# sourceMappingURL=index.js.map
